import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) {
      setError(error.message);
      return;
    }
    navigate('/kontant-avstemming', { replace: true });
  };

  const inputClass = 'w-full bg-transparent border-0 border-b-2 border-slate-500 focus:border-slate-300 focus:ring-0 font-mono text-sm outline-none py-2';

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-950 text-slate-50">
      <div className="flex flex-col gap-6 w-72">
        <h1 className="font-mono text-sm text-slate-400">kontant.backstube.no</h1>
        <form onSubmit={handleSignIn} className="flex flex-col gap-6">
        <input
          type="email"
          placeholder="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={inputClass}
          required
        />
        <input
          type="password"
          placeholder="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={inputClass}
          required
        />
        {error && (
          <p className="font-mono text-xs text-red-400">{error}</p>
        )}
        <button
          type="submit"
          disabled={loading}
          className="font-mono text-[11px] md:text-xs text-slate-400 hover:text-slate-200 underline self-start disabled:opacity-50"
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      </div>
    </div>
  );
}

export default Login;
